import Phaser from 'phaser';
import { GAME_HEIGHT } from '../config/constants';

export type PowerUpType = 'rapidFire' | 'butterShield' | 'jamSpread';

export interface PowerUpConfig {
  type: PowerUpType;
  texture: string;
  duration: number; // ms
  color: number;
}

export const POWER_UP_CONFIGS: Record<PowerUpType, PowerUpConfig> = {
  rapidFire: {
    type: 'rapidFire',
    texture: 'powerup_rapidfire',
    duration: 10000,
    color: 0xff6600,
  },
  butterShield: {
    type: 'butterShield',
    texture: 'powerup_shield',
    duration: 10000,
    color: 0xffdd00,
  },
  jamSpread: {
    type: 'jamSpread',
    texture: 'powerup_spread',
    duration: 10000,
    color: 0xff0066,
  },
};

export class PowerUp extends Phaser.Physics.Arcade.Sprite {
  public powerUpType: PowerUpType;
  private fallSpeed: number = 100;
  private glowTime: number = 0;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    type: PowerUpType,
    group: Phaser.Physics.Arcade.Group
  ) {
    const config = POWER_UP_CONFIGS[type];
    super(scene, x, y, config.texture);

    this.powerUpType = type;

    // Add to scene and group
    scene.add.existing(this);
    group.add(this);

    // Enable physics
    scene.physics.add.existing(this);

    // Set velocity downward
    this.setVelocityY(this.fallSpeed);

    // Set hitbox
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setSize(24, 24);

    // Random rotation
    this.glowTime = Math.random() * Math.PI * 2;
  }

  update(_time: number, delta: number): void {
    // Floating/pulsing animation
    this.glowTime += delta * 0.005;
    this.setScale(1 + Math.sin(this.glowTime) * 0.1);
    this.rotation = Math.sin(this.glowTime * 0.5) * 0.2;

    // Destroy if off screen
    if (this.y > GAME_HEIGHT + 20) {
      this.destroy();
    }
  }

  getConfig(): PowerUpConfig {
    return POWER_UP_CONFIGS[this.powerUpType];
  }
}





